import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import {
	ActivatedRouteSnapshot,
	CanActivate,
	CanDeactivate,
	CanLoad,
	NavigationStart,
	Route,
	Router,
	RouterStateSnapshot
} from "@angular/router";
import { DialogComponent } from "src/app/ui/dialog/dialog.component";
import { SnackBarComponent } from "src/app/ui/snack-bar/snack-bar.component";
import { AccessProfileService } from "../services/access-profile.service";
import { LoginService } from "../services/login.service";
import { ComponentCanDeactivate } from "./component-can-deactivate";

@Injectable()
export class LoggedInGuard implements CanLoad, CanActivate, CanDeactivate<ComponentCanDeactivate> {
	routerCanDeactive: string;
	go = false;

	constructor(
		private loginService: LoginService,
		private accessProfileService: AccessProfileService,
		private dialog: MatDialog,
		private snackBar: MatSnackBar,
		private router: Router
	) {
		this.router.events.subscribe(val => {
			if (val instanceof NavigationStart) {
				this.routerCanDeactive = val.url;
			}
		});
	}

	checkAuthentication(path: string): boolean {
		const loggedIn = this.loginService.isLoggedIn();
		if (!loggedIn) {
			this.loginService.handleLogin();
		}
		return loggedIn;
	}

	canLoad(route: Route): boolean {
		return this.checkAuthentication(route.path);
	}

	async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		const nameMenu = this.returnNameMenu(state.url);

		if (nameMenu === "") {
			this.snackBar.openFromComponent(SnackBarComponent, {
				data: "Rota não encontrada"
			});
		} else if (!!nameMenu && nameMenu?.toUpperCase() === "PAGINA EXTERNA") {
			return this.checkAuthentication(state.url);
		} else {
			const res = await this.accessProfileService.getProfiliesClaimLink(nameMenu);
			if (nameMenu === "Home") {
				localStorage.setItem("home", JSON.stringify(res.data.item2));
			} else {
				localStorage.setItem("profileClaim", res?.data.item1.actions.toString());
				if (nameMenu === "Consulta e Cadastro de Propostas e Emissões") {
					localStorage.setItem("propostas", JSON.stringify(res.data.item1));
				}
				if (state.url.split("/").includes("consultar")) {
					const read = res.data.item1.actions.includes("read");
					if (read) {
						return this.checkAuthentication(state.url);
					} else {
						this.router.navigate(["home"]);
						this.snackBar.openFromComponent(SnackBarComponent, {
							data: "Usuário sem permissão"
						});
						return;
					}
				} else if (state.url.split("/").includes("cadastrar")) {
					const post = res.data.item1.actions.includes("post");
					if (post) {
						return this.checkAuthentication(state.url);
					} else {
						this.router.navigate(["home"]);
						this.snackBar.openFromComponent(SnackBarComponent, {
							data: "Usuário sem permissão"
						});
						return;
					}
				} else if (state.url.split("/").includes("editar")) {
					const put = res.data.item1.actions.includes("put");
					if (put) {
						return this.checkAuthentication(state.url);
					} else {
						this.router.navigate(["home"]);
						this.snackBar.openFromComponent(SnackBarComponent, {
							data: "Usuário sem permissão"
						});
						return;
					}
				}
			}
			return this.checkAuthentication(state.url);
		}
	}

	canDeactivate(component: ComponentCanDeactivate): boolean {
		if (!component.canDeactivate()) {
			if (this.go) {
				this.go = false;
				return !component.canDeactivate();
			} else {
				if (component.visualizando || component.modalidadeProposal) this.backtoFilter();
				else this.showModal();

				return component.canDeactivate();
			}
		} else {
			return true;
		}
	}

	backtoFilter() {
		this.go = true;
		this.router.navigate([this.routerCanDeactive]);
	}

	showModal() {
		const dialogRef = this.dialog.open(DialogComponent, {
			data: { title: "Atenção!", text: "Os dados inseridos não foram salvos. Deseja prosseguir?" },
			height: "238px",
			width: "480px"
		});
		dialogRef.componentInstance.firstNameButton = "SIM";
		dialogRef.componentInstance.secondNameButton = "NÃO";
		dialogRef.componentInstance.eventFirstButton.subscribe(res => {
			this.go = true;
			this.router.navigate([this.routerCanDeactive]);
		});
	}

	returnNameMenu(menu: string): string {
		let nameMenu: string;
		if (menu.split("/").length >= 2) {
			nameMenu = menu.split("/")[1];
		} else {
			nameMenu = menu.split("/")[2];
		}

		if (nameMenu === "parametros") {
			nameMenu = menu.split("/")[2];
		}

		switch (nameMenu) {
			case "home":
				return "Home";
			case "manutencao":
				return "Manutenção da Home";
			case "meu-perfil":
				return "Meu Perfil";
			case "tomador":
				return "Consulta e Cadastro de Tomador";
			case "ccg-tomador":
				return "Consulta e envio de CCG";
			case "segurado":
				return "Consulta e Cadastro de Segurado";
			case "propostas":
				return "Consulta e Cadastro de Propostas e Emissões";
			case "estrutura-comercial":
				return "Consulta e Cadastro de Estrutura Comercial";
			case "tabela-recursal-tomador":
				return "Tabela Recursal Tomador";
			case "tabela-recursal":
				return "Tabela Recursal";
			case "clausula":
				return "Cláusulas e Condições";
			case "taxa-mix":
				return "Taxa Mix";
			case "produto-cobertura":
				return "Parâmetros e Cobertura";
			case "perfil-acesso":
				return "Consulta e Criação de Perfil de Acesso";
			case "usuario":
				return "Consulta e Criação de Usuário";
			case "auditoria":
				return "Trilha de Auditoria";
			case "log-de-erro":
				return "log-de-erro";
			case "liberacao-proposta-tomador":
				return "Liberação de Propostas por Tomador";
			case "trilha-auditoria":
				return "Trilha de Auditoria";
			case "objeto-segurado":
				return "Objeto Segurado";
			case "pagina-externa":
				return "Pagina Externa";
			case "not-found":
				return "404";
			default:
				return "";
		}
	}
}
